import { mapState } from 'vuex';
import f from "@/application/shared/functions.js";

export default {
	name: 'share',
	props: {
		url : String,
		message : String,
		subject : String,
		images : Array,
		files : Array,
		settings : Object,
		auto : {
			type : Boolean,
			default : true
		},
		createLink : Function
	},

	data : function(){

		return {
			loading : false,
			values : {}
		}

	},

	created() {
		if (this.settings && this.settings.savels){

			try{
				this.values = JSON.parse(localStorage[this.settings.savels] || "{}")
			}
			catch(e){
				console.log(e)
			}

		}

		if(!this.settings && this.auto){
			if (this.ways.length == 1){
				this.ways[0].action()
			}
		}
		
	},

	watch: {
		//$route: 'getdata'
	},
	computed: mapState({
		auth : state => state.auth,

		cordova : function(){return window.cordova},

		composedUrl : function(){
			return this.url + this.parameters
		},

		parameters : function(){
			var v = _.reduce(this.values, (m, v, i) => {
				return v ? (m + '&' + i + '=1') : m + ''
			}, '')

			return v ? '?' + v : ''
		},

		filesimages : function(){
			return (this.files || []).concat(_.map(this.images || [], (i, j) => {

				var type = i.split(';')[0].split(':')[1]
	
				return {
					base64 : i,
					name : 'image_' + j,
					type : type,
	
					ftype : 'image'
				}
			}))
		},

		canshare : function(){
			return window.cordova || (!this.filesimages.length && (this.message || this.subject || this.url))
		},


		cancopyurl : function(){
			return this.url && !this.filesimages.length && !this.message && !this.subject
		},

		cangetlink : function(){
			return this.createLink
		},

		ways : function(){
			var items = []

			if(this.canshare){
				items.push({
					action : this.sharelink,
					icon : 'fas fa-share-alt',
					name : 'Share',
					text : 'caption.share'
				})
			}

			if(this.cancopyurl){
				items.push({
					action : this.copylink,
					icon : 'fas fa-link',
					name : 'Copy link',
					text : 'caption.copyurl'
				})
			}

			if(this.cangetlink){
				items.push({
					action : this.getlink,
					icon : 'fas fa-link',
					name : 'Get link',
					text : 'caption.getlink'
				})
			}



			return items
		}
	}),

	methods : {

		getlink : function(){

			this.$store.commit('globalpreloader', true)

			this.createLink().then((link) => {
				this.copylink_d(link)
			}).catch(e => {

				console.error(e)

				this.$store.commit('icon', {
					icon: 'error',
					message: "There was an error creating the link"
				})

			}).finally(() => {
				this.$store.commit('globalpreloader', false)
			})
		},
		sharelink : function(e){
			this.nativeshare(e)
		},

		changesettings : function(v){
			this.values = v

			if (this.settings && this.settings.savels){
				localStorage[this.settings.savels] = JSON.stringify(this.values)
			}
		},

		nativeshare : function(e){

			if (e && e.target)
				e.target.blur();

			this.$emit('close')

			var plugin = f.deep(window, 'plugins.socialsharing')

			if(!plugin){

				this.core.vueapi.sharesocial({url : this.url, title : this.subject, message : this.message})
				return
			}

			plugin.shareWithOptions({

				message: this.message || '', 
				subject: this.subject || '',
				files : _.map((this.files || []), (f) => {return f.base64}).concat(this.images || []),
				url: this.composedUrl

			}, () => {

			   

			}, function(){

			});
		},

		copylink : function(){
			this.copylink_d(this.composedUrl || '')
		},

		copylink_d(url){
			f.copytext(url)

			
			this.core.sitemessage(this.$t('labels.lcopied'))

			this.$emit('close')
		},

		
	},
}